// App-side delegate for `@heidi/commerce/data` (D2, ARCFE-972). See the
// revert sibling for the shape.
//
// The `instanceof AxiosError` test stays HERE on purpose. The legacy hook
// toasted only for axios errors and silently swallowed everything else;
// keeping the test app-side preserves that exactly, where hoisting it into
// the package would have meant naming axios in the package surface and
// dropping it would have started toasting on errors that never toasted.
import { type ErrorResponse } from '@/types';
import { useMutateExtendReverseTrial as useMutateExtendReverseTrialCore } from '@heidi/commerce/data';
import { toast } from '@heidi/design-system/toast';
import { useTranslations } from '@heidi/runtime/i18n';
import { AxiosError } from 'axios';
import { invalidateCurrentUser } from '../query/useQueryUser';
import { invalidateCurrentUserBillingInfo } from '../query/useQueryUserBillingInfo';

export function useMutateExtendReverseTrial() {
  const { t } = useTranslations();

  return useMutateExtendReverseTrialCore({
    onExtendSuccess: (hours) => {
      void invalidateCurrentUser();
      void invalidateCurrentUserBillingInfo();
      toast({
        tone: 'success',
        title:
          hours > 1
            ? t('extendFreeTrialModal.trialExtendedSuccess_plural', {
                count: hours,
              })
            : t('extendFreeTrialModal.trialExtendedSuccess', { count: hours }),
      });
    },
    onExtendError: (error) => {
      if (error instanceof AxiosError) {
        const errorData = error.response?.data as ErrorResponse;
        toast({
          tone: 'destructive',
          title: t('extendFreeTrialModal.failedToExtendTrial'),
          description: errorData.detail.msg || 'An error occurred',
        });
      }
    },
  });
}
